import axios, { AxiosError, AxiosHeaders } from 'axios';

import { identity, logout } from 'src/hocs/AuthProvider';

const createAxiosInstance = (url: string) => {
  const api = axios.create({
    baseURL: url,
  });

  api.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
      const { response } = error;
      if (response) {
        if (response.status === 401) {
          try {
            await logout(true);
          } catch {}
        }
        if (response.status === 403 && !response.data) {
          response.data = "You don't have permission to access.";
        }
        if (response.data instanceof Blob) {
          const textFromBlob = await response.data.text();
          try {
            response.data = JSON.parse(textFromBlob);
          } catch {
            response.data = textFromBlob;
          }
        }
      }
      return Promise.reject(error);
    },
  );

  api.interceptors.request.use(async (config) => {
    const { accessToken } = identity.getCookieAuthState() || {};
    try {
      if (!config.headers) config.headers = {} as AxiosHeaders;
      if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
    } catch {}
    return config;
  });

  return api;
};

export default createAxiosInstance;
